import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUserService } from './core/services/user/current-user.service';
import { environment } from '../environments/environment';
import { UserRole } from '../enums/roles.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private currentUserService: CurrentUserService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentUser = this.currentUserService.GetSession();
    if (currentUser && currentUser.token) {
      if (currentUser.role !== UserRole.Admin) {
        console.log('Auth Guard: Redirecting');
        
        window.location.href = environment.apiLocations.derm;
        return false;
      }

      return true;
    } else {
      if (typeof window !== 'undefined') {
        window.location.href = `${environment.apiLocations.login}`;
      }
      return false;
    }
  }
}
